// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__0ayMG","row":"default_row__fuVD6","link":"default_link__5jvU5"};